// Client Onboarding Service - API calls for invitation token validation and password setup

import { api } from '@/services/api';

export interface ValidateTokenResponse {
  valid: boolean;
  client_name: string | null;
  email: string | null;
}

export interface SetPasswordResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  refresh_expires_in: number;
  user: Record<string, unknown>;
}

export const clientOnboardingService = {
  async validateToken(token: string): Promise<ValidateTokenResponse> {
    const { data } = await api.post('/client-onboarding/validate-token', { token });
    return data;
  },

  async setPassword(token: string, password: string): Promise<SetPasswordResponse> {
    const { data } = await api.post('/client-onboarding/set-password', { token, password });
    return data;
  },
};
